module.exports = __webpack_public_path__ + "img/zs-2-icon.2800b479.png";